import React, { useEffect, useState } from 'react'
import PrivateLayout from '../components/PrivateLayout'
import Footer from '../components/Footer'
import OrganizationSummary from '../components/OrganizationSummary'

const ResearcherList: React.FC = (): JSX.Element => {
  return (
    <PrivateLayout>
      <div className="content">
        <OrganizationSummary />

        <div className="row mt-3">
          <div className="col-12">
            <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white pt-6 border-top border-300">
              <div id="projectSummary">
                <div className="row align-items-end justify-content-between pb-4 g-3">
                  <div className="col-auto">
                    <h3>Researchers</h3>
                  </div>
                </div>

                <div className="row align-items-center g-3 justify-content-between justify-content-start mb-3">
                  <div className="col-12 col-sm-auto">
                    <div className="search-box mb-2 mb-sm-0">
                      <form className="position-relative" data-bs-toggle="search" data-bs-display="static">
                        <input
                          className="form-control search-input search"
                          type="search"
                          placeholder="Search Researcher"
                          aria-label="Search"
                        />
                        <span className="fas fa-search search-box-icon"></span>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="table-responsive ms-n1 ps-1 scrollbar">
                  <table className="table fs--1 mb-0 border-top border-200">
                    <thead>
                      <tr>
                        <th
                          className="sort align-middle ps-3"
                          scope="col"
                          data-sort="firstName"
                          style={{ width: '10%' }}
                        >
                          First Name
                        </th>
                        <th
                          className="sort align-middle ps-3"
                          scope="col"
                          data-sort="lastName"
                          style={{ width: '10%' }}
                        >
                          Last Name
                        </th>
                        <th className="sort align-middle ps-3" scope="col" data-sort="email" style={{ width: '10%' }}>
                          Email
                        </th>
                        <th
                          className="sort align-middle ps-3"
                          scope="col"
                          data-sort="grantCount"
                          style={{ width: '10%' }}
                        >
                          Grant Count
                        </th>
                        <th
                          className="sort align-middle ps-3"
                          scope="col"
                          data-sort="grantAward"
                          style={{ width: '10%' }}
                        >
                          Grant Award
                        </th>
                      </tr>
                    </thead>
                    <tbody className="list" id="project-summary-table-body">
                      <tr className="position-static">
                        <td className="align-middle time fs--1 white-space-nowrap ps-3 firstName">
                          <p className="mb-0 fs--1 text-900">Robert</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 lastName">
                          <p className="mb-0 fs--1 text-900">Emmons</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 email">
                          <p className="mb-0 fs--1 text-900">raemmons@ucdavis.edu</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 grantCount">
                          <p className="mb-0 fs--1 text-900">20</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 grantAward">
                          <p className="mb-0 fs--1 text-900">$554,925.00</p>
                        </td>
                      </tr>

                      <tr className="position-static">
                        <td className="align-middle time fs--1 white-space-nowrap ps-3 firstName">
                          <p className="mb-0 fs--1 text-900">James</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 lastName">
                          <p className="mb-0 fs--1 text-900">Arthur</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 email">
                          <p className="mb-0 fs--1 text-900">j.arthur@bham.ac.uk</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 grantCount">
                          <p className="mb-0 fs--1 text-900">25</p>
                        </td>
                        <td className="align-middle white-space-nowrap ps-3 grantAward">
                          <p className="mb-0 fs--1 text-900">$600,925.00</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="row align-items-center justify-content-between py-2 pe-0 fs--1">
                  <div className="col-auto d-flex">
                    <p
                      className="mb-0 d-none d-sm-block me-3 fw-semi-bold text-900"
                      data-list-info="data-list-info"
                    ></p>
                    <a className="fw-semi-bold" href="#!" data-list-view="*">
                      View all<span className="fas fa-angle-right ms-1" data-fa-transform="down-1"></span>
                    </a>
                    <a className="fw-semi-bold d-none" href="#!" data-list-view="less">
                      View Less<span className="fas fa-angle-right ms-1" data-fa-transform="down-1"></span>
                    </a>
                  </div>
                  <div className="col-auto d-flex">
                    <button className="page-link" data-list-pagination="prev">
                      <span className="fas fa-chevron-left"></span>
                    </button>
                    <ul className="mb-0 pagination"></ul>
                    <button className="page-link pe-0" data-list-pagination="next">
                      <span className="fas fa-chevron-right"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </PrivateLayout>
  )
}

export default ResearcherList
